<script>
import GoodWizard from "@/components/vue-good-wizard/vue-good-wizard.vue";
import rfqStatewideMake from "@/views/repairers/rfq/rfq-statewide/rfq-statewide-make.vue";
import RfqStatewideAddParts from "@/views/repairers/rfq/rfq-statewide/rfq-statewide-add-parts.vue";
import rfqStatewideTime from "@/views/repairers/rfq/rfq-statewide/rfq-statewide-time.vue";
import HomePage from "@/views/home/Home.vue";
import Axios from "axios";
import { mapActions, mapGetters } from 'vuex'
import WebCamera from '@/components/utility/web-camera.vue'
import {isMobile} from "mobile-device-detect";
import _ from "lodash";
export default {
  name: "rfq-statewide",
  data() {
    return{
      isMobile,
      isShowCameraVin: false,
      isShowCameraPart: false,
      isShowBrowseVin: false,
      isShowBrowsePart: false,
      vehicleVinPhotos: [],
      partsPhotos: [],
      addPartsFormData: {
        make: '',
        vinVehicle: '',
        estimateNumber: '',
        parts: [],
        description: '',
        partNumber: '',
      },
      timeFormData: {
        date: null,
        time: null,
        jobNumber: null,
        QPNumber: null,
        comments: null,
      },
      selectedFile: null,
      isAuth: false,
      steps: [
        {
          label: 'Select Manufacturer',
          slot: 'rfq-add-step-1',
          class: 'rfq-add-steps rfq-add-step-1',
          isAdvert: 'both',
        },
        {
          label: 'Create Parts List',
          slot: 'rfq-add-step-2',
          class: 'rfq-add-steps rfq-add-step-2',
          isAdvert: 'both',
        },
        {
          label: 'Time',
          slot: 'rfq-add-step-3',
          class: 'rfq-add-steps rfq-add-step-3',
          isAdvert: 'both',
          options: {
            nextDisabled: true, // control whether next is disabled or not
          },
        },
      ],
      step: 1,
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: 'currentCompany/getDetails',
    })
  },
  methods: {
    ...mapActions({
      updateRFQTable: 'repairer/rfq/getRFQsForTableView',
    }),
    receiveRfq: function (justUpdate = false) {
      NProgress.start()
      const data = {
        parts: _.cloneDeep(this.addPartsFormData.parts),
        vin: this.addPartsFormData.vinVehicle,
        make: this.addPartsFormData.make,
        comments: this.timeFormData.comments,
        QPNumber: this.addPartsFormData.QPNumber || this.timeFormData.QPNumber || this.timeFormData.jobNumber,
        date: this.timeFormData.date,
        time: this.timeFormData.time,
      }

      Axios.post(`/ir/repairer/rfq/add-receive`, data)
          .then(response => {
            NProgress.done()
            if (response.data.status && response.data.id > 0) {
              this.updateRFQTable()
              if (!justUpdate) {
                this.$toast.success('New quote has been received - Ref ' + response.data.number)
              }
              this.$router.push({ path: '/r/rfq/' + response.data.id })

              return
            }
          })
          .catch(error => {
            if (!justUpdate) { this.$toast.error('An error occurred in receiving your Request For Quote') }
            NProgress.done()
          })

    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          let base64 = e.target.result

          if (this.isShowBrowseVin) {
            this.vehicleVinPhotos.push(base64)
          } else {
            this.partsPhotos.push(base64)
          }
          this.isShowBrowseVin = false;
          this.isShowBrowsePart = false;
        };
        reader.readAsDataURL(file);
      }
    },
    openCameraVin() {
      if (this.isMobile) {
        this.isShowCameraVin = true
      } else {
        this.isShowBrowseVin = true
        this.$refs.fileInputVinParts.click()
      }
    },
    openCameraParts() {
      if (this.isMobile) {
        this.isShowCameraPart = true
      } else {
        this.isShowBrowsePart = true
        this.$refs.fileInputVinParts.click()
      }
    },
    onCloseCamera(photos) {
      // Store the camera type before resetting flags
      const wasVinCamera = this.isShowCameraVin;

      // Reset camera flags
      this.isShowCameraVin = false;
      this.isShowCameraPart = false;

      // Handle photos if any were taken
      if (photos && photos.length > 0) {
        if (wasVinCamera) {
          this.vehicleVinPhotos = photos;
        } else {
          this.partsPhotos = photos;
        }
      }
    },
    sendQuote () {
      // if (!this.currentCompany.capricornNumber || !this.currentCompany.email) {
      //   this.$toast.error('Capricorn Number and email must not be empty')
      //   return
      // }
      let data = {
        parts: this.addPartsFormData.parts,
        vin: this.addPartsFormData.vinVehicle,
        make: this.addPartsFormData.make,

        comments: this.timeFormData.comments,
        QPNumber: (!_.isEmpty(this.addPartsFormData.QPNumber))? this.addPartsFormData.QPNumber: this.timeFormData.QPNumber,
        date: this.timeFormData.date,
        time: this.timeFormData.time,
      }
      Axios.post('/ir/stw/quote', data).then((r) => {
        if (r.data._status && r.data.id && Number(r.data.id) > 0) {
            this.updateRFQTable()
            this.$toast.success('New quote has been submitted - Ref ' + r.data.number)
            this.$router.push({ path: '/r/rfqs#submitted' })
            return

        } else {

        }
      }).catch((e) => {
        this.$toast.error('An error occurred in sending your Quote')
      })
    },
    onFileChangeQuotePdf(event) {
      const file = event.target.files[0];
      if (file && file.type === 'application/pdf') {
        this.selectedFile = file;
        this.uploadFile();
      }
    },
    async uploadFile() {
      if (!this.selectedFile) {
        return;
      }

      try {
        const formData = new FormData();
        formData.append('file', this.selectedFile);

        await Axios.post('test', formData)
      } catch (error) {
      }
    },
    goodWizardNext() {
      this.$refs.StatewideAddStepper.goNext()
      if (this.step == 2){
        this.step = 3
      }
    },
    goodWizardBack(){
      this.step = 2
      this.$refs.StatewideAddStepper.goTo(1)
    },
    isSelectManufacturer(){
      this.$refs.StatewideAddStepper.goTo(0)
      this.step = 1
    },
    isCreatePartsList(){
      this.$refs.StatewideAddStepper.goTo(1)
      this.step = 2
    },
    clickCancel: function () {
      this.$router.push({ name: 'RepairerDashboard' })
    },

  },
  components: {
    RfqStatewideAddParts,
    GoodWizard,
    rfqStatewideMake,
    rfqStatewideTime,
    WebCamera
  }
}
</script>

<template>
  <div class="">
    <web-camera
        v-if="isShowCameraPart || isShowCameraVin"
        @close="onCloseCamera"
        :multiple="isShowCameraPart"
        :sendAfterTakePhoto="isShowCameraPart"
    ></web-camera>
    <div v-else class="rfq-add-page">
      <div class="page-header">
        <h4>Request for Quotes</h4>
        <ol class="breadcrumbs">
          <li class="breadcrumb-item home">
            <router-link to="/r">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/r/rfqs">View Quotes</router-link>
          </li>
          <li class="breadcrumb-item active">Submit New Quote</li>
        </ol>
      </div>
      <good-wizard
          class="good-wizard-block"
          :steps="steps"
          :step="step"
          :currentStep="step"
          ref="StatewideAddStepper">
      </good-wizard>
      <div class="main-block d-flex">
        <div class="left-block">
          <div class="statewide-head">
            <div class="d-flex justify-content-between">
              <div v-show="step == 1" class="statewide-head-title">Select a Manufacturer</div>
              <div v-show="step == 2" class="statewide-head-title">Create Parts List</div>
              <div v-show="step == 3" class="statewide-head-title">Date & Time Quote Required</div>
              <div v-show="false && step == 2" class="block-btn-import">
                <button @click="$refs.fileInput.click()" class="btn btn-primary pull-right button-next">Import Quote PDF</button>
                <input
                    type="file"
                    ref="fileInput"
                    @change="onFileChangeQuotePdf"
                    accept=".pdf"
                    style="display: none;"
                />
              </div>
              <div class="d-flex">
                <div>
                  <i @click="isCreatePartsList" :class="{'active': step == 2}" class='bx bx-list-ul'></i>
                </div>
                <div>
                  <i @click="isSelectManufacturer" :class="{'active': step == 1}" class='bx bx-customize'></i>
                </div>
              </div>
            </div>
            <div class="left-block">
              <rfq-statewide-make v-if="step == 1" @selected="v => (addPartsFormData.make = v, step = 2, this.$refs.StatewideAddStepper.goNext())" @cancelPage="clickCancel"></rfq-statewide-make>
              <rfq-statewide-add-parts v-if="step == 2" v-model="addPartsFormData" @nextPage="goodWizardNext" @openCameraVin="openCameraVin" @openCameraParts="openCameraParts"></rfq-statewide-add-parts>
              <rfq-statewide-time v-if="step == 3" v-model="timeFormData" @backPage="goodWizardBack" @cancelPage="clickCancel" @send="sendQuote" @receive="receiveRfq"></rfq-statewide-time>
            </div>
          </div>
        </div>
        <div class="right-banner">
          <div v-if="step !== 1" class="block-left-dealer">
            <div class="block-left-dealer-title">Your Dealership</div>
            <div class="block-left-dealer-name">AUDI - Zagame Automotive</div>
            <div class="block-left-dealer-info">Tullamarine - 3043</div>
          </div>
          <div class="right-banner-item-purple">
            <div>FAST Service</div>
            <div>FAST Delivery</div>
          </div>
          <div  class="right-banner-item-grey">
            <div>Australia`s leading</div>
            <div>GENUINE Parts Hub</div>
          </div>
          <div class="right-banner-item-white">
            <div class="right-banner-item-white-elem">
              <div class="right-banner-item-white-elem-title">
                Connect with In-House Experts
              </div>
            </div>

            <div class="right-banner-item-white-elem">
              <div class="right-banner-item-white-elem-title">
                Shop with Confidence
              </div>
            </div>

          </div>

        </div>
      </div>

    </div>

    <input
        type="file"
        ref="fileInputVinParts"
        @change="onFileChange"
        accept=".jpg, .jpeg, .png"
        style="display: none;"
    />
  </div>
</template>

<style scoped>
.main-block{
  max-width: 1200px;
  margin: 7px auto;
  font-size: 18px;
  padding: 40px 0;
}
.left-block{
  width: 900px;
  margin-right: 20px;
}
.right-banner{
  margin-top: 30px;
  width: 260px;
  font-size: 20px;
  position: sticky;
  top: 5px;
  height: 100%;
}
.right-banner-item-purple{
  background-color: #562a78;
  color: #fdcb2d;
  border-radius: 5px;
  font-weight: 600;
  padding: 20px;
  text-align: center;
}
.right-banner-item-grey{
  background-color: #d7d7d7;
  color: rgb(88, 43, 121);
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  font-weight: 600;
}
.right-banner-item-white{
  font-weight: 400;
  padding: 40px 20px;
  font-size: 16px;
}
.right-banner-item-white-elem{
  margin-bottom: 20px;
}
.right-banner-item-white-elem-title{
  font-weight: 800;
}
.statewide-head-title{
  font-weight: 800;
  color: #3f3f3f;
}
.statewide-head .bx{
  font-size: 35px;
  cursor: pointer;
  color: #828282;
}
.statewide-head .bx.active{
  color: #2f56a0;
}
.statewide-head .bx-list-ul{
  margin-right: 25px;
}
.good-wizard-block{
  position: sticky;
  top: 135px;
  background-color: #FFFFFF;
  z-index: 1000;
}
.good-wizard-block >>> .sticky .wizard__divider{
  height: auto;
}
.good-wizard-block >>> .wizard__body{
  display: none;
}
.block-left-dealer{
  margin-top: 10px;
  border: 2px solid rgb(110, 48, 158);
  border-radius: 5px;
  padding: 10px 20px;
  margin-bottom: 20px;
}
.block-left-dealer-title{
  font-weight: 600;
  font-size: 15px;
}
.block-left-dealer-name{
  font-weight: 600;
  font-size: 15px;
  margin-top: 5px;
  color: rgb(110, 48, 158);
}
.block-left-dealer-info{
  font-weight: 400;
  font-size: 15px;
  margin-top: 5px;
}
@media (max-width: 1280px) {
  .main-block{
    max-width: 900px;
    padding-right: 20px;
    padding-left: 20px;
  }
  .left-block{
    width: 100%;
    margin-right: 0;
  }
  .right-banner{
    display: none;
  }
  .good-wizard-block >>> .sticky .wizard__divider{
    display: block;
  }
}
@media (max-width: 1000px) {
  .main-block{
    max-width: 750px
  }
  .good-wizard-block >>> .sticky .wizard__divider{
    display: block;
  }
}
@media (max-width: 768px) {
  .V3 .rfq-add-page .good-wizard-block >>> .wizard__steps{
    width: 100%;
    min-width: auto;
  }
  .left-block{
    width: 100%;
    padding: 20px;
  }
  .left-block .left-block{
    padding: 0;
  }
  .right-banner{
    display: none;
  }
  .main-block{
    padding: 0;
  }
  .block-btn-import{
    display: none;
  }
}
</style>
